import { useEffect, useRef } from 'react'

export default function VideoModal({ embedUrl, onClose }) {
  const dialogRef = useRef(null)

  useEffect(() => {
    const dialog = dialogRef.current
    if (!dialog) return undefined
    if (embedUrl) {
      if (!dialog.open) dialog.showModal()
    } else if (dialog.open) {
      dialog.close()
    }
    return undefined
  }, [embedUrl])

  return (
    <dialog
      ref={dialogRef}
      className="p-0 bg-transparent backdrop:bg-black/80 rounded-3xl overflow-hidden max-w-4xl w-[90vw]"
      onClose={onClose}
      onClick={(e) => {
        if (e.target === dialogRef.current) onClose()
      }}
    >
      <div className="relative aspect-video bg-black">
        {embedUrl && (
          <iframe
            className="w-full h-full"
            src={embedUrl}
            title="Media gallery video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        )}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 text-white bg-black/50 p-2 rounded-full hover:bg-black"
          aria-label="Close video"
        >
          ✕
        </button>
      </div>
    </dialog>
  )
}
